import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { showErrors } from '../../modules/general';
import { apiFetch, apiSearch } from '../../modules/utility';
const apiBase = 'queuedVendorBill';

const mapStateToProps = (state, ownProps) => {
	let queuedVendorBills;
	let queuedVendorBill;
	let queuedVendorBillId;

	if (state.lists.queuedVendorBillIds) {
		queuedVendorBills = _.map(
			state.lists.queuedVendorBillIds,
			(id) => state.maps.queuedVendorBill[id]
		);
	}

	if (ownProps.queuedVendorBill) {
		queuedVendorBill = ownProps.queuedVendorBill;
	} else {
		queuedVendorBillId = ownProps.queuedVendorBillId
			? ownProps.queuedVendorBillId
			: _.get(ownProps, ['match', 'params', 'queuedVendorBillId']);
		queuedVendorBill = _.get(state.maps, ['queuedVendorBill', queuedVendorBillId]);
	}

	return {
		queuedVendorBill,
		queuedVendorBills,
		authUser: state.auth.authUser,
		userMap: state.maps.user,
		resourceMap: state.maps.resource,
		supplierMap: state.maps.supplier,
		quickbooksItemMap: state.maps.quickbooksItem,
	};
};

const search = (p = {}) => {
	const { callback = _.noop } = p;
	return (dispatch) => {
		apiSearch({
			base: apiBase,
			params: {
				forTabs: true,
			},
			dispatch,
			callback,
		});
	};
};

const get = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			getQueuedVendorBill: get,
			queuedVendorBillSearch: search,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
